
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { InventoryBin } from '../../../../backend/backendapi';
import { formatDateTime } from '../../../../../util';

@Component({
  name: 'TabGeneral',
  components: {
  },
})
export default class TabGeneral extends Vue {
  @Prop({ required: true })
  readonly bin!: InventoryBin | null;

  formatDateTime = formatDateTime;

  get createdBy(): string {
    return '(unknown)';
  }

  get updatedBy(): string {
    return '(unknown)';
  }
}
